import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Spinner from "../app/shared/Spinner.jsx";

import { inspectorEntity } from "../components/entity/inspector.entity.js";
import Inspection, { inspectionEntity } from "../components/entity/Inspection.jsx";
import { reportByDateAndDniEntity } from "../components/report/reportByDateAndDni.entity.js";
import { reportMapaEntity } from "../components/report/reportMapa.entity.js";

import Error404 from "./user-pages/Error404.jsx";
import Login from "../components/Login.jsx";
import ForgotPassword from "../components/ForgotPassword.jsx";
import UserProfile from "./shared/UserProfile";
import { emvEntity } from "../components/entity/emv.entity.js";

const MainPage = lazy(() => import("./user-pages/MainPage.jsx"));
const TerminosCondiciones = lazy(() => import("./user-pages/TerminosCondiciones.jsx"));
const PoliticaPrivacidad = lazy(() => import("./user-pages/PoliticaPrivacidad.jsx"));

const Inspector = lazy(() => import("../components/entity/Inspector.jsx"));
const InspectorCreate = lazy(() => import("../components/create-views/InspectorCreate.jsx"));
const InspectorModify = lazy(() => import("../components/modify-views/InspectorModify"));
const InspectorView = lazy(() => import("../components/info-views/InspectorView.jsx"));
const ReportByDateAndDni = lazy(() => import("../components/report/ReportByDateAndDni.jsx"));
const InspectionView = lazy(() => import("../components/info-views/InspectionView"));
const MapaInspectionView = lazy(() => import("../components/info-views/MapaInspectionView"));
const ReportMapa = lazy(() => import("../components/report/ReportMapa.jsx"));
const Emv = lazy(() => import("../components/entity/Emv.jsx"));
const SupervisorABM = lazy(() => import("../components/entity/SupervisorABM.jsx"));

const AppRoutes = () => {
  const user = UserProfile.getInstance();
  const isAuthenticated = !!user.getToken();

  const hasGeneralPermisson = user.hasGeneralPermisson();
  const hasInspectorCreatePermisson = user.hasInspectorCreatePermisson();
  const hasInspectorShowPermisson = user.hasInspectorShowPermisson();
  const hasInspectionShowPermisson = user.hasInspectionShowPermisson();
  const hasEmvRole = user.hasEmvRole();
  const hasSupervisorABMRole = user.hasSupervisorABMRole();
  const canViewMap = user.canViewMap();

  const hasAnyRole = hasGeneralPermisson || hasEmvRole || hasSupervisorABMRole;

  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {!isAuthenticated ? (
          <Route path="*" element={<Navigate to="/login" replace />} />
        ) : (
          <>
            <Route path="/" element={hasAnyRole ? <MainPage /> : <Error404 />} />

            {/* Inspector - ROUTE */}
            <Route
              path={`/${inspectorEntity.friendlyPath}/crear`}
              element={
                hasInspectorCreatePermisson ? (
                  <InspectorCreate entity={inspectorEntity} />
                ) : (
                  <Error404 />
                )
              }
            />
            <Route
              path={`/${inspectorEntity.friendlyPath}/informacion-detallada/:id`}
              element={
                hasInspectorShowPermisson ? (
                  <InspectorView path={inspectorEntity.path} />
                ) : (
                  <Error404 />
                )
              }
            />
            <Route
              path={`/${inspectorEntity.friendlyPath}/modificar/:id`}
              element={
                hasInspectorCreatePermisson ? (
                  <InspectorModify entity={inspectorEntity} />
                ) : (
                  <Error404 />
                )
              }
            />
            {/* Inspector - ROUTE END */}

            {/* ReportByDateAndDni - ROUTE START */}
            <Route
              path={`/${reportByDateAndDniEntity.friendlyPath}/informacion-detallada/:id`}
              element={
                hasInspectionShowPermisson ? (
                  <InspectionView path={inspectionEntity.path} />
                ) : (
                  <Error404 />
                )
              }
            />
            {/* ReportByDateAndDni - ROUTE END */}

            {/* Mapa - ROUTE START */}
            <Route
              path={`/${reportMapaEntity.friendlyPath}`}
              element={
                canViewMap ? <ReportMapa /> : <Error404 />
              }
            />
            <Route
              path={`/${reportMapaEntity.friendlyPath}/informacion-detallada/:id`}
              element={
                canViewMap ? (
                  <MapaInspectionView path={inspectionEntity.path} />
                ) : (
                  <Error404 />
                )
              }
            />
            {/* Mapa - ROUTE END */}

            {/* EMV - ROUTE START */}
            <Route
              path={`/${emvEntity.friendlyPath}`}
              element={hasEmvRole ? <Emv /> : <Error404 />}
            />
            {/* EMV - ROUTE END */}
            {/* Create Supervisor - ROUTE START */}
            <Route
              path="/supervisor-abm"
              element={hasSupervisorABMRole ? <SupervisorABM /> : <Error404 />}
            />
            {/* Create Supervisor - ROUTE END */}

            <Route
              path={`/${inspectorEntity.friendlyPath}`}
              element={<Inspector />}
            />
            <Route
              path={`/${reportByDateAndDniEntity.friendlyPath}`}
              element={<ReportByDateAndDni />}
            />

            <Route path="/terminos" element={<TerminosCondiciones />} />
            <Route path="/privacidad" element={<PoliticaPrivacidad />} />

            <Route path="/user-pages/error-404" element={<Error404 />} />
            <Route path="*" element={<Error404 />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
